import React, { ReactNode, useId, useRef, useState } from 'react';

import './CollapsableSection.scss';

interface CollapsableSectionProps {
  title: ReactNode;
  children: ReactNode;
  expanded?: boolean;
  showScrollToTopButton?: boolean;
}

export const CollapsableSection = ({
  title,
  children,
  expanded = false,
  showScrollToTopButton = false
}: CollapsableSectionProps) => {
  const [isExpanded, setExpanded] = useState(expanded);
  const sectionRef = useRef<HTMLDivElement>(null);
  const collapsableId = useId();

  return (
    <section className='sr-collapsable-section'>
      <div className='sr-collapsable-section__title' ref={sectionRef}>
        {title}
        <button
          className='sr-collapsable-section__button'
          aria-controls={collapsableId} 
          onClick={() => setExpanded((prev) => !prev)}
        >
          {isExpanded ? '[Collapse]' : '[Expand]'}
        </button>
      </div>
      
      {isExpanded ? (
        <>
          <div id={collapsableId} className='sr-collapsable-section__content'>
            {children}
          </div>
          {showScrollToTopButton ? (
            <button
              className='sr-collapsable-section__button'
              aria-controls={collapsableId} 
              onClick={() => sectionRef?.current?.scrollIntoView({
                behavior: 'smooth'
              })}
            >
            Scroll to top of section
            </button>
          ) : null}
        </>
      ) : null}
    </section>
  );
};